module.exports = __webpack_public_path__ + "img/avatar5.542d2187.png";